/** 设置 -> 规划 -> 日历，以及案件期限（第二阶段 P2-2，P19-P20）。 */
export default {
  calendar: {
    title: '工作日日历',
    description: '按工作日计算期限时使用的周末和公共假期。公布新年度时请导入，并可在此添加本机构自己的休息日。',
    originTenant: '已为本机构保存',
    originPack: '默认日历（尚未保存）',
    originNone: '没有日历：在导入日历之前，无法计算任何期限（无论按工作日还是日历日）。',
    revision: '修订版 {{revision}}',
    coverage: '涵盖 {{from}} 至 {{to}}',
    timezone: '时区：{{zone}}',
    weekends: '周末',
    weekendOpen: '{{days}}，自 {{from}} 起',
    weekendClosed: '{{days}}，{{from}} 至 {{to}}',
    holidays: '假期',
    provisional: '暂定',
    source: '来源',
    noSource: '无公开来源',
    remove: '删除',
    removeTitle: '删除 {{name}}（{{date}}）？',
    removeBody: '保存后计算的期限将把 {{date}} 视为工作日。此操作会保存日历的新修订版。',
    removeReplacements: '以下补假日将一并删除：',
    removeRestore:
      '添加表单无法重新创建公共假期或补假日。如需日后恢复，请导入包含该日期的日历文件；可先导出日历以保留副本。',
    removeConfirm: '删除假期',
    removeCancel: '取消',
    add: '添加假期或休息日',
    date: '日期',
    nameMs: '名称（马来文）',
    nameEn: '名称（英文）',
    kind: '类型',
    kindAdhoc: '已宣布的假期（附公开来源）',
    kindTenant: '本机构的休息日',
    sourceUrl: '来源网址',
    note: '备注',
    addSubmit: '添加',
    nameRequired: '请输入名称。',
    dateRequired: '请选择日历涵盖范围内的日期。',
    sourceRequired: '已宣布的假期需要其公告的链接。',
    import: '导入 JSON 文件',
    export: '导出为 JSON',
    schema: '下载文件格式（JSON 架构）',
    importFailed: '无法将该文件读取为 JSON。',
    saved: '日历已保存（修订版 {{revision}}）。',
    saving: '正在保存日历…',
    notNewer: '此日历已有更新的版本（修订版 {{revision}}）。请重新加载页面后再试。',
    uncovered: '没有截止日期的进行中期限：{{count}} 个。它们的计算超过 {{to}}；请导入涵盖它们的日历。',
    uncoveredNoCalendar: '没有截止日期的进行中期限：{{count}} 个。没有日历，无法计算其中任何期限；请导入日历。',
    loadFailed: '无法加载日历。',
  },
  clocks: {
    title: '期限',
    running: '进行中',
    paused: '已暂停',
    stopped: '已停止',
    expired: '已届满',
    due: '截止 {{date}}',
    dueSoon: '即将到期',
    noDue: '无截止日期',
    uncovered: '尚无日历涵盖此期限。',
    workingDays: '个工作日',
    calendarDays: '个日历日',
    extensions: '延期次数：{{count}}',
    pausedFor: '暂停时长：{{days}} 天',
  },
} as const
